'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _rule = require('./rule');

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (name, token) {
	var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	var group = opts.group,
	    optional = opts.optional;

	var strings = [];

	if (!Array.isArray(token)) {
		throw new TypeError('expects Array for group rules.');
	}

	if (group) {
		strings.push(optional ? '[' : '(');
	}

	token = token.map(function (item) {
		// contains weights?
		return Array.isArray(item) ? '/' + item[1] + '/ ' + item[0] : item;
	});

	strings.push(token.join(' | '));

	if (group) {
		strings.push(optional ? ']' : ')');
	}

	return (0, _rule2.default)(name, strings.join(' '));
};


//////////////////
// WEBPACK FOOTER
// ./~/jspeech/lib/stringify/types/alt.js
// module id = 201
// module chunks = 0